"use strict";
angular.module("resouceLimitModule", ['tManageMentServiceModule'])
    .controller("resouceLimitCtrl", ["$scope", "$modalInstance", "tManageMentService", "item", "trsHttpService", "modalDialog", "$validation", function($scope, $modalInstance, tManageMentService, item, trsHttpService, modalDialog, $validation) {
        initStatus();
        initData();
        /** [initStatus description: 初始化状态] */
        function initStatus() {
            $scope.data = {
                userNum: item.TENANTLIMIT.tenantUserNum,
                siteNum: item.TENANTLIMIT.tenantSiteNum,
                areaSize: "5",
                allAreaSize: item.TENANTLIMIT.tenantAreaSize,
                STARTTIME: item.STARTTIME,
                ENDTIME: item.ENDTIME,
                ObjectId: item.TENANTID,
                tipsinfo: item.TENANTLIMIT.tenantAreaSize
            };
            $scope.status = {
                expandShow: false,
                tipsinfoStatus: false
            };
        }
        /** [initData description: 初始化数据] */
        function initData() {
            $scope.percentageSize = $scope.data.areaSize / $scope.data.allAreaSize * 100 + '%';
        }
        /** [confirm description:确定保存信息] */
        $scope.confirm = function() {
            if ($scope.status.tipsinfoStatus) return;
            var limit = '{"tenantUserNum":' + $scope.data.userNum + ', "tenantSiteNum":' + $scope.data.siteNum + ', "tenantAreaSize":' + $scope.data.allAreaSize + '}';
            var updataParams = {
                serviceid: "mlf_tenant",
                methodname: "updateTenantInfo",
                ObjectId: item.TENANTID,
                TENANTLIMIT: limit,
                STARTTIME: item.STARTTIME,
                ENDTIME: item.ENDTIME,
                STATUS: item.STATUS
            };
            $validation.validate($scope.resouceLimit).success(function() {
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), updataParams, 'post').then(function(data) {
                    if (data.ISSUCCESS == 'true') {
                        modalDialog.alertType('', '更新租户信息成功', "success", false);
                    } else {
                        modalDialog.alertType('', '更新租户信息失败', "error", false);
                    }
                    $modalInstance.close(data);
                });
            }).error(function() {
                modalDialog.alertType("", "请检查填写项!", 'error', 'confirm');
            });
        };
        /** [checkmodifiedCapacity description]输入并检验数值的大小 */
        $scope.checkmodifiedCapacity = function(){
            if($scope.data.allAreaSize < $scope.data.tipsinfo){
                $scope.status.tipsinfoStatus = true;
            }else {
                $scope.status.tipsinfoStatus = false;
            }
        };
        //点击关闭
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        //点击扩容并弹出扩容弹窗
        $scope.expandCapacity = function() {
            $scope.status.expandShow = true;
        };

    }]);